import { Message } from 'element-ui'

/**
 * 获取当前位置（PC 端 · 高德 v2.0）
 * @returns {Promise<Object>}
 *
 * resolve 数据结构：
 * {
 *   lng: Number,
 *   lat: Number,
 *   accuracy: Number,
 *   address: String | null,
 *   source: location_type-看高德文档,
 *   isConverted: true,
 * }
 */
export function getCurrentLocation(options = {}) {
  const { timeout = 10000, enableHighAccuracy = true } = options;

  return new Promise((resolve, reject) => {
    if (!window.AMap) {
      reject({ code: "SDK_NOT_READY", message: "高德 SDK 未加载" });
      return;
    }

    AMap.plugin("AMap.Geolocation", () => {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy,
        timeout,
        extensions: 'all'
      });

      geolocation.getCurrentPosition(async (status, result) => {
        if (status !== "complete") {
          console.log('高德定位----',result)
          resolve({
            lng: '',
            lat: '',
            accuracy: 0,
            address: '未知',
            source: '',
            isConverted: false,
          })
          return
        }
        try {
          let lng = result.position.lng;
          let lat = result.position.lat;
          // 逆地理编码
          const address = await regeocode(lng, lat);
          if (result.accuracy < 100) {
            resolve({
              lng,
              lat,
              accuracy: result.accuracy,
              address: address?.formattedAddress || '未知',
              source: result?.location_type,
              isConverted: true,
            });
          }else{
            resolve({
              lng,
              lat,
              accuracy: result.accuracy,
              address: address?.addressComponent.province + address?.addressComponent.city || '未知',
              source: result?.location_type,
              isConverted: true,
            });
          }
        } catch (e) {
          reject({
            code: "CONVERT_OR_GEOCODE_FAILED",
            message: e || "坐标转换或地址解析失败",
          });
        }
      });
    });
  });
}

/**
 * 逆地理编码（经纬度 → 地址）
 */
function regeocode(lng, lat) {
  return new Promise((resolve, reject) => {
    AMap.plugin("AMap.Geocoder", () => {
      const geocoder = new AMap.Geocoder();
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === "complete" && result.regeocode) {
          resolve(result.regeocode);
        } else {
          reject(result);
        }
      });
    });
  });
}

// 根据经纬度计算距离（米）
export function getDistance(lat1, lng1, lat2, lng2) {
  const R = 6371000; // 地球半径（米）
  const toRad = deg => deg * Math.PI / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // 返回米
}

// 判断浏览器有没有开启位置权限
export async function checkGeolocationPermission() {
  if (!navigator.permissions) return 'unknown'
  try {
    const result = await navigator.permissions.query({ name: 'geolocation' })
    return result.state // 'granted' | 'denied' | 'prompt'
  } catch (e) {
    return 'unknown'
  }
}